import { useState } from 'react';
import api from '@/services/api';

interface HierarchyNode {
  id: string;
  name: string;
  level_type: string;
  level: number;
  parent_id?: string;
  status: string;
  children?: HierarchyNode[];
  expanded?: boolean;
}

interface UseHierarchyOperationsProps {
  hierarchyType: 'functional' | 'business' | 'geographic';
  onRefresh: () => Promise<void>;
  onError: (error: string) => void;
}

export const useHierarchyOperations = ({ 
  hierarchyType, 
  onRefresh, 
  onError 
}: UseHierarchyOperationsProps) => {
  const [selectedNode, setSelectedNode] = useState<HierarchyNode | null>(null);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  const handleDeleteNode = async () => {
    if (!selectedNode) return;
    
    try {
            const response = await api.delete(`/hierarchy/${hierarchyType}/${selectedNode.id}`, {
        data: { cascadeDelete: true }
      });
      
            
      if (response.status === 200 || response.status === 204) {
                await onRefresh();
        setShowDeleteConfirm(false);
        setSelectedNode(null);
              } else {
                // No action needed for non-200/204 responses
              }
    } catch (err) {
      console.error('Delete error:', err);
      onError('Failed to delete node');
    }
  };

  const handleDeleteClick = async (node: HierarchyNode) => {
    setSelectedNode(node);
    
    try {
            const response = await api.delete(`/hierarchy/${hierarchyType}/${node.id}`, {
        data: { cascadeDelete: true }
      });
      
            
      if (response.status === 200 || response.status === 204) {
                await onRefresh();
        setSelectedNode(null);
              } else {
                // No action needed for non-200/204 responses
              }
    } catch (err) {
      console.error('Delete error:', err);
      onError('Failed to delete node');
    }
  };

  const closeDeleteConfirm = () => {
    setShowDeleteConfirm(false);
    setSelectedNode(null);
  };

  return {
    // State
    selectedNode,
    setSelectedNode,
    showDeleteConfirm,
    
    // Actions
    handleDeleteNode,
    handleDeleteClick,
    closeDeleteConfirm,
  };
};
